/* eslint-disable no-bitwise */
import isEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import dayjs from 'dayjs';
import router from '../router/router';

const hexTable = [];

for (let i = 0; i < 256; i += 1) {
  hexTable[i] = (i < 16 ? '0' : '') + i.toString(16);
}

export function generateUuid() {
  const d0 = (Math.random() * 0xFFFFFFFF) | 0;
  const d1 = (Math.random() * 0xFFFFFFFF) | 0;
  const d2 = (Math.random() * 0xFFFFFFFF) | 0;
  const d3 = (Math.random() * 0xFFFFFFFF) | 0;

  return (
    `${hexTable[d0 & 0xFF]
    + hexTable[(d0 >> 8) & 0xFF]
    + hexTable[(d0 >> 16) & 0xFF]
    + hexTable[(d0 >> 24) & 0xFF]
    }-${
      hexTable[d1 & 0xFF]
    }${hexTable[(d1 >> 8) & 0xFF]
    }-${
      hexTable[((d1 >> 16) & 0x0F) | 0x40]
    }${hexTable[(d1 >> 24) & 0xFF]
    }-${
      hexTable[(d2 & 0x3F) | 0x80]
    }${hexTable[(d2 >> 8) & 0xFF]
    }-${
      hexTable[(d2 >> 16) & 0xFF]
    }${hexTable[(d2 >> 24) & 0xFF]
    }${hexTable[d3 & 0xFF]
    }${hexTable[(d3 >> 8) & 0xFF]
    }${hexTable[(d3 >> 16) & 0xFF]
    }${hexTable[(d3 >> 24) & 0xFF]}`
  );
}

/* eslint-disable */
export function declOfNum(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}

export function pluralize(number, one, two, five) {
  let n = Math.abs(number);

  n %= 100;
  if (n >= 5 && n <= 20) {
    return five;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return two;
  }
  return five;
}

export const dateTimeItem = {
  format: (date) => {
    if (date === null) {
      return "";
    }
    let dateTime = new Date(date);
    let result = [
      ("0" + dateTime.getDate()).slice(-2),
      ("0" + (dateTime.getMonth() + 1)).slice(-2),
      dateTime.getFullYear(),
    ].join(".");
    result +=
      " " +
      [("0" + dateTime.getHours()).slice(-2), ("0" + dateTime.getMinutes()).slice(-2)].join(":");
    return result;
  },
};

export function browser() {
  var ua = navigator.userAgent;
  var tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ");
}

export function getDeviceName() {
  var deviceName = "";

  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    Datalogic: function () {
      return navigator.userAgent.match(/DL-AXIS/i);
    },
    Bluebird: function () {
      return navigator.userAgent.match(/EF500/i);
    },
    Honeywell: function () {
      return navigator.userAgent.match(/CT50/i);
    },
    Zebra: function () {
      return navigator.userAgent.match(/TC70|TC55/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Datalogic() ||
        isMobile.Bluebird() ||
        isMobile.Honeywell() ||
        isMobile.Zebra() ||
        isMobile.BlackBerry() ||
        isMobile.Android() ||
        isMobile.iOS() ||
        isMobile.Windows()
      );
    },
  };

  if (isMobile.Datalogic()) {
    deviceName = "Datalogic";
  } else if (isMobile.Bluebird()) {
    deviceName = "Bluebird";
  } else if (isMobile.Honeywell()) {
    deviceName = "Honeywell";
  } else if (isMobile.Zebra()) {
    deviceName = "Zebra";
  } else if (isMobile.BlackBerry()) {
    deviceName = "BlackBerry";
  } else if (isMobile.iOS()) {
    deviceName = "iOS";
  } else if (deviceName === "" && isMobile.Android()) {
    deviceName = "Android";
  } else if (deviceName === "" && isMobile.Windows()) {
    deviceName = "Windows";
  }

  return deviceName || "desktop";
}

// size = (s-64) (m-150) (l-376) (xxl-1920)
// version (f - front) (b-back)
export function nftImage(token, size = "m", version = "f") {
  const CDN_BASE = "https://d2jr7zu5plag1m.cloudfront.net";

  function canUseWebP() {
    const lStorage = localStorage.getItem("can-use-webp");

    if (lStorage !== null) {
      return +lStorage;
    }

    let canUse = false;
    var elem = document.createElement("canvas");

    // eslint-disable-next-line
    if (!!(elem.getContext && elem.getContext("2d"))) {
      canUse = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }

    localStorage.setItem("can-use-webp", canUse ? "1" : "0");

    return false;
  }

  const ext = canUseWebP() ? "webp" : "png";

  size = String(size).toUpperCase();

  const retina = window.devicePixelRatio > 1 ? "@2x" : "";

  // eslint-disable-next-line
  const { contract_id, contract_token_id } = token;

  // eslint-disable-next-line
  if (+contract_id !== 1) {
    version = "";
  }

  // eslint-disable-next-line
  return `${CDN_BASE}/pics/${version}${contract_id}-${contract_token_id}-${size}${retina}.${ext}`;
}

export function nftContainer(contract_id = 1, trophy = false) {
  // base 2x3
  // eslint-disable-next-line
  if (contract_id === 1) {
    return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAADCAQAAAAT4xYKAAAADklEQVR42mNkAAJGOAEAAC0ABNxMS2YAAAAASUVORK5CYII=";
  }

  // trofy 1x1
  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
}

export function makeId(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function createId(value) {
  if (!value) {
    return "";
  }
  const CHARS = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "yo",
    ж: "zh",
    з: "z",
    и: "i",
    й: "y",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "h",
    ц: "c",
    ч: "ch",
    ш: "sh",
    щ: "shch",
    ъ: "",
    ы: "y",
    ь: "",
    э: "e",
    ю: "yu",
    я: "ya",
  };
  let transformValue = value.toLowerCase();
  for (var char in CHARS) {
    transformValue = transformValue.replace(new RegExp(char, "g"), CHARS[char]);
  }
  return transformValue.replace(/\W+/g, "-").replace(/(^-|-$)/g, "");
}

export function setCookie(name, value, options) {
  options = options || {};

  let expires = options.expires;

  if (typeof expires === "number" && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }

  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  var updatedCookie = `${name}=${value}`;

  for (var propName in options) {
    updatedCookie += `; ${propName}`;
    const propValue = options[propName];

    if (propValue !== true) {
      updatedCookie += `=${propValue}`;
    }
  }

  document.cookie = updatedCookie;
}

export function getCookie(name) {
  if (typeof document === "undefined") {
    return null;
  }

  var matches = document.cookie.match(
    new RegExp(
      // eslint-disable-next-line
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"
    )
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function getValue(object, value, defaultValue = null) {
  let result = defaultValue;

  if (typeof value === "undefined") {
    return result;
  }

  function isObject(value) {
    return value && typeof value === "object";
  }

  if (!isObject(object)) {
    return result;
  }

  const innerGetValue = (object, value) => {
    if (!isObject(object)) {
      return null;
    }

    return isNil(object[value]) ? null : object[value];
  };

  const keys = value.split(".");

  result = object;

  for (const i in keys) {
    // eslint-disable-next-line no-prototype-builtins
    if (keys.hasOwnProperty(i)) {
      result = innerGetValue(result, keys[i]);

      if (result === null) {
        result = defaultValue;
        break;
      }
    }
  }

  return result;
}

export function forEach(listItems, callback) {
  for (const key in listItems) {
    // eslint-disable-next-line no-prototype-builtins
    if (listItems.hasOwnProperty(key)) {
      if (callback(listItems[key], key) === false) {
        break;
      }
    }
  }
}

export function isObject(value) {
  return value !== null && typeof value === "object";
}

export function isFunction(value) {
  return typeof value === "function";
}

export function isNil(value) {
  return typeof value === "undefined" || value === null;
}

export function isEmpty(value) {
  if (typeof value === "string") {
    return String(value).trim().length === 0;
  }

  return isNil(value);
}

/*
 * сортировка
 * extractor - название колонки (если это массив объектов)
 * reverse - default=false сортировать в обратном порядке
 * */
export function sort(array, extractor, reverse) {
  if (!Array.isArray(array)) {
    return array;
  }

  extractor = extractor || null;
  reverse = reverse || false;

  const sort = (sArray, sReverse) => {
    let data = sArray.slice().sort((a, b) => a - b);

    if (sReverse) {
      data = data.reverse();
    }

    return data;
  };

  const sortWithExtractor = (eArray, element, eReverse) => {
    let data = eArray.slice().sort((i, ii) => {
      if (i[element] > ii[element]) {
        return 1;
      } else if (i[element] < ii[element]) {
        return -1;
      }

      return 0;
    });

    if (eReverse) {
      data = data.reverse();
    }

    return data;
  };

  if (extractor) {
    return sortWithExtractor(array, extractor, reverse);
  }

  return sort(array, reverse);
}

/*
 * сортировка
 * extractor - название колонки (если это массив объектов)
 * reverse - default=false сортировать в обратном порядке
 * */
export function sortByString(items, extractor, reverse = false) {
  return items.sort((a, b) => {
    return reverse
      ? b[extractor].localeCompare(a[extractor])
      : a[extractor].localeCompare(b[extractor]);
  });
}

/**
 * Синхронный враппер try/catch
 *
 * @param {Function} func
 * @param {Function} errorHandler
 * @returns
 */
export const tryWrapper = (func, errorHandler = () => {}) => {
  let res;
  try {
    res = func();
  } catch (e) {
    errorHandler(e);
  }
  return res;
};

export function removeObjectKeys(targetObject, keysArray) {
  const result = {};
  Object.entries(targetObject).forEach(([key, value]) => {
    if (!keysArray.includes(key)) {
      result[key] = value;
    }
  });
  return result;
}

export function formatterToRub(value) {
  if (!value) {
    return "";
  }
  const formatter = new Intl.NumberFormat("ru", {
    style: "currency",
    currency: "RUB",
    minimumFractionDigits: 2,
    currencyDisplay: "symbol",
  });
  return formatter.format(value);
}

export const formatter = {
  numberLength(value, maxLength) {
    let validValue = value.replace(/\D/g, "");
    if (value.length > maxLength) {
      validValue = validValue.slice(0, maxLength);
    }
    return validValue;
  },
  kpp(value) {
    return formatter.numberLength(value, 9);
  },
  inn(value) {
    return formatter.numberLength(value, 10);
  },
  ogrn(value) {
    return formatter.numberLength(value, 13);
  },
  phone(value) {
    if (!value) {
      return '';
    }
    let number = value.replace(/\D/g, "");
    let result = null;
    const [firstSymbol] = number;
    if (["7", "8", "9"].indexOf(firstSymbol) > -1) {
      if (firstSymbol === "9") {
        number = `7${number}`;
      }
      const firstSymbols = number[0] === "8" ? "8" : "+7";
      result = `${firstSymbols} `;
      if (number.length > 1) {
        result += `(${number.substring(1, 4)}`;
      }
      if (number.length >= 5) {
        result += `) ${number.substring(4, 7)}`;
      }
      if (number.length >= 8) {
        result += `-${number.substring(7, 9)}`;
      }
      if (number.length >= 10) {
        result += `-${number.substring(9, 11)}`;
      }
    } else {
      result = `+${number.substring(0, 16)}`;
    }
    return result;
  },
  dateTime(value) {
    const result = dayjs(value).format("DD.MM.YYYY HH:mm");
    return result !== "Invalid Date" ? result : "";
  },
  date(value) {
    const result = dayjs(value).format("DD.MM.YYYY");
    return result !== "Invalid Date" ? result : "";
  },
  price(value) {
    if (!value) {
      return "";
    }
    const ftr = new Intl.NumberFormat("ru", {
      style: "currency",
      currency: "RUB",
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    });
    return ftr.format(value);
  },
  quantity(value, e) {
    if (!value) {
      return "";
    }
    const numbers = value.replace(/\D/g, "");
    const ftr = new Intl.NumberFormat("ru", {
      minimumFractionDigits: 3,
    });
    return ftr.format(value);
  },
  boolean(value) {
    if (value === null) {
      return "Не указано";
    }
    return value ? "Да" : "Нет";
  },
};

export const validator = {
  email(value) {
    if (!value) {
      return true;
    }
    return /\S+@\S+\.\S+/.test(value);
  },
  phone(value) {
    if (!value) {
      return true;
    }
    return value[0] === "+" ? value.length > 17 : value.length > 16;
  },
};
export function currencyFormatter(value, currency) {
  if (!value) {
    return "";
  }
  let postFix = "";
  const props = {
    minimumFractionDigits: 2,
    currencyDisplay: "symbol",
  };

  switch (currency) {
    case "USD":
    case "usd":
    case "доллар":
      props["currency"] = "USD";
      props["style"] = "currency";
      break;
    case "UAH":
    case "гривна":
      props["currency"] = "UAH";
      props["style"] = "currency";
      break;
    case "BDT":
    case "така":
      props["currency"] = "BDT";
      props["style"] = "currency";
      break;
    case "EUR":
    case "евро":
      props["currency"] = "EUR";
      props["style"] = "currency";
      break;
    case "руб.":
    case "RUB":
      props["currency"] = "RUB";
      props["style"] = "currency";
      break;
    default:
      if (currency) {
        postFix = " " + currency.toString();
      }
      break;
  }

  return new Intl.NumberFormat("ru", props).format(value) + postFix;
}

export function booleanFormatter(value) {
  if (value === null) {
    return "Не указано";
  }
  return value ? "Да" : "Нет";
}

export function quantityFormater(value) {
  if (!value) {
    return "";
  }
  const formatter = new Intl.NumberFormat("ru", {
    minimumFractionDigits: 3,
  });
  return formatter.format(value);
}

export function getNumberOfDays(start, end) {
  const date1 = new Date(start);
  const date2 = new Date(end);
  const oneDay = 1000 * 60 * 60 * 24;
  const diffInTime = date2.getTime() - date1.getTime();
  const diffInDays = Math.round(diffInTime / oneDay);
  return diffInDays;
}

export function scrollToHeader() {
  document.getElementsByTagName("body")[0].scrollIntoView({ behavior: "smooth" });
}

export function createRequest(paramsObj) {
  const result = {};
  Object.entries(paramsObj).forEach(([key, value]) => {
    if (typeof value === "number") {
      result[key] = value;
      return;
    }
    if (typeof value === "object" && value !== null && Object.keys(value).length) {
      result[key] = value;
      return;
    }
    if (value) {
      result[key] = value;
    }
  });
  return result;
}

export function getRolesString(rolesArray) {
  if (Array.isArray(rolesArray)) {
    return rolesArray.map((role) => role.title).join(", ");
  }
  if (typeof rolesArray === "string") {
    return rolesArray;
  }
  return "";
}

export function dateFormat(date) {
  const format = "DD.MM.YYYY";
  return date ? dayjs(date).format(format) : "";
}

/**
 * Получаем числа с пробелами
 * @param num само число
 * @param n через
 * @param x через 3 знака
 * @param s ставим пробел
 * @param c
 * @returns {string}
 */
export function priceFormat (num, n = 0, x = 3, s = ' ', c) {
  if (num === '' || num === null) {
    return ''
  }

  const re = `\\d(?=(\\d{${x || 3}})+${n > 0 ? '\\D' : '$'})`

  const [num2, dec] = String(parseFloat(num).toFixed(2)).split('.')

  let res = (c ? num2.replace('.', c) : num2).replace(new RegExp(re, 'g'), `$&${s || ','}`)

  if (dec > 0) {
    res = `${res}.${dec}`
  }

  return res
}

/**
 * Меняем формат даты и времени
 * @param {string} dateString
 */
export function humanDateTimeToServer(dateString) {
  let result = '';
  let dateResult = '';
  let timeResult = '';
  const [date, time] = String(dateString).split(' ');

  if (date && time) {
    result = new Date(`${date.split('.').reverse().join('-')}T${time}`);
    dateResult = new Date(date.split('.').reverse().join('-'));
    timeResult = time
  } else if (date) {
    result = new Date(date.split('.').reverse().join('-'));
    dateResult = new Date(date.split('.').reverse().join('-'));
  }

  return {
    result,
    date: dateResult,
    time: timeResult
  }
}

export function saveParamsToQuery(params) {
  const _params = pickBy({ ...router.currentRoute.value.query, ...params }, identity);
  if (!params.page || params.page === 1) {
    delete _params.page;
  }
  Object.keys(_params).forEach((key) => (_params[key] = "" + _params[key]));
  if (!isEqual(router.currentRoute.value.query, _params)) {
    router.push({ query: _params, params: { isSaveParams: true } });
  }
}

function getType(val) {
  const types = [Number, String, Boolean, Object, Array, Function, Date, Symbol];
  const value = types.includes(val) ? val() : val;
  const result = Object.prototype.toString.call(value).match(/object (\w+)/) || [];
  return result[1];
}

function compareTypes(value, model) {
  const valueType = getType(value);
  const modelType = Array.isArray(model) ? model.map(getType) : getType(model);
  return Array.isArray(modelType) ? modelType.includes(valueType) : modelType === valueType;
}

export function templateEngine(scheme, dataList = [], params = {}) {
  const schemeMatches = Object.keys(scheme);
  const results = [];
  dataList.forEach((data) => {
    const result = {};
    Object.entries(scheme).forEach(([schemeKey, schemeValue]) => {
      // в объекте scheme для каждого ключа с полем required = true должно быть значение default одного из типов,
      // перечисленных в поле type

      const matchCondition = schemeValue.matchCondition;
      if (
        typeof schemeValue.matchCondition == "string" &&
        !schemeMatches.includes(matchCondition)
      ) {
        console.error(
          `[TE-MATCH]: Элемент с полем name, равным ${data.name}, указывает связь с полем ${matchCondition}, которого нет в объекте scheme.`
        );
        return false;
      }

      // устанавливаем значение в зависимости от ключа, по которому совершаем match в params[schemeKey]
      const paramsDataKey = matchCondition ? data[matchCondition] : data.name;
      const paramsValueForKey = params[schemeKey]?.[paramsDataKey];

      if (schemeValue.required && data[schemeKey] === undefined) {
        if (paramsValueForKey !== undefined) {
          const isAllowedType =
            schemeValue.type !== undefined
              ? compareTypes(paramsValueForKey, schemeValue.type)
              : true;
          if (!isAllowedType) {
            console.error(
              `[TE-TYPE]: Элемент с полем name, равным ${data.name}, имеет тип для поля ${schemeKey}, не соответствующий допустимым типам.`
            );
            return false;
          }
          result[schemeKey] = paramsValueForKey;
        } else {
          result[schemeKey] = schemeValue.default;
        }
      } else if (data[schemeKey] !== undefined) {
        result[schemeKey] = data[schemeKey];
      } else if (paramsValueForKey !== undefined) {
        result[schemeKey] = paramsValueForKey;
      }

      if (schemeValue.allowed !== undefined && result[schemeKey] !== undefined) {
        const allowedMistakes = (result[schemeKey] || [])
          .filter((key) => !schemeValue.allowed.includes(key))
          .join(", ");
        if (allowedMistakes) {
          console.error(
            `[TE-VALUE]: Элемент с полем name, равным ${
              data.name
            }, имеет значения для поля ${schemeKey}, не соответствующие допустимым. Недопустимые значения: ${allowedMistakes}; допустимые значения: ${schemeValue.allowed.join(
              ", "
            )}`
          );
          return false;
        }
      }
      return true;
    });
    results.push(result);
  });

  return results;
}

// Функции для блокировки скролла тега body. Используется при открывании всклывающих окон
let scrollPosition = 0

let isDesktop = true

if (typeof window !== 'undefined') {
  isDesktop = window.innerWidth > 1191

  window.addEventListener('resize', () => {
    isDesktop = window.innerWidth > 1191
  })
}

export const lockBodyScroll = () => {
  if (window.scrollLockCounter) {
    window.scrollLockCounter += 1
    return
  }
  window.scrollLockCounter = 1

  // Считаем размер отступа справа от страницы - там, где был скроллбар. Если в браузере скроллбар не занимает место, то offset = 0
  const offset = window.innerWidth - document.documentElement.clientWidth + 'px'

  scrollPosition = window.pageYOffset

  document.body.classList.add('lock-scroll')
  // трюк для ios
  // if (!isDesktop) {
    document.body.style.top = `-${scrollPosition}px`
  // }

  document.body.style.marginRight = offset

  document.body.setAttribute('data-scroll-locked', true)
  document.body.setAttribute('data-scroll-position', scrollPosition)
  // для fixed элементов задаем внутренний отступ, так как они игнорируют оступ, который мы выставили для body
  const headerFixed = document.querySelector('.js-app-header.is-sticky .js-app-header-desktop-main')
  const headerMenu = document.querySelector('.js-app-header.is-sticky .js-header-catalog-menu-container')
  if (headerFixed) headerFixed.style.paddingRight = offset
  if (headerMenu) headerMenu.style.paddingRight = offset
}

export const unlockBodyScroll = () => {
  if (window.scrollLockCounter > 1) {
    window.scrollLockCounter -= 1
    return
  }
  if (window.scrollLockCounter === 0) {
    return
  }
  window.scrollLockCounter = 0

  document.body.classList.remove('lock-scroll')
  document.body.style.marginRight = '0'

  document.body.removeAttribute('data-scroll-locked')
  document.body.removeAttribute('data-scroll-position')

  // if (!isDesktop) {
    document.body.style.removeProperty('top')
    window.scrollTo(0, scrollPosition)
  // }

  const headerFixed = document.querySelector('.js-app-header.is-sticky .js-app-header-desktop-main')
  const headerMenu = document.querySelector('.js-app-header.is-sticky .js-header-catalog-menu-container')
  if (headerFixed) headerFixed.style.paddingRight = '0'
  if (headerMenu) headerMenu.style.paddingRight = '0'
}
